"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_2 = { class: "text-left font-bold uppercase border-b border-slate-400" };
const _hoisted_3 = { class: "text-center" };
const _hoisted_4 = { class: "text-center" };
const _hoisted_5 = { class: "text-right" };
const _hoisted_6 = { class: "text-right" };
const _hoisted_7 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_8 = { class: "text-left font-bold uppercase border-b border-slate-400" };
const _hoisted_9 = { class: "font-bold" };
const _hoisted_10 = { class: "font-bold" };
const _hoisted_11 = { class: "font-bold" };
const _hoisted_12 = { class: "font-bold" };
const _hoisted_13 = { class: "text-center" };
const _hoisted_14 = { class: "text-right" };
const _hoisted_15 = { class: "text-right" };
const _hoisted_16 = { key: 2 };
const _hoisted_17 = { class: "text-left font-bold uppercase border-b border-slate-400" };
const _hoisted_18 = { class: "font-bold" };
const _hoisted_19 = { class: "font-bold" };
const _hoisted_20 = { class: "font-bold" };
const _hoisted_21 = { class: "font-bold" };
const _hoisted_22 = { class: "text-center" };
const _hoisted_23 = { class: "text-right" };
const _hoisted_24 = { class: "text-right" };
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ordersStore_1 = require("../../stores/orders/ordersStore");
//LOCAL VARIABLES
exports.default = (0, vue_1.defineComponent)({
    __name: 'OrderItems',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const ordersStore = (0, ordersStore_1.useOrdersStore)();
        //COMPUTED
        const orderItems = (0, vue_3.computed)(() => ordersStore.orderItems);
        const orderItemOpenedListFields = (0, vue_3.ref)([
            {
                key: "productId",
                label: (_a = (0, i18n_1.trans)("item_id_opened_list", "Item ID", "order_items")) !== null && _a !== void 0 ? _a : "Item ID",
                value: "productId",
            },
            {
                key: "productName",
                label: (_b = (0, i18n_1.trans)("name_opened_list", "Name", "order_items")) !== null && _b !== void 0 ? _b : "Name",
                value: "productName",
            },
            {
                key: "quantity",
                label: (_c = (0, i18n_1.trans)("quantity_opened_list", "Quantity", "order_items")) !== null && _c !== void 0 ? _c : "Quantity",
                value: "quantity",
            },
            {
                key: "reservedQuantity",
                label: (_d = (0, i18n_1.trans)("reserved_quantity_opened_list", "Reserved Quantity", "order_items")) !== null && _d !== void 0 ? _d : "Reserved Quantity",
                value: "reservedQuantity",
            },
            {
                key: "formattedPriceUnitNet",
                label: (_e = (0, i18n_1.trans)("net_unit_price_opened_list", "Net Unit Price", "order_items")) !== null && _e !== void 0 ? _e : "Unit Net Price",
                value: "formattedPriceUnitNet",
            },
            {
                key: "formattedNetAmount",
                label: (_f = (0, i18n_1.trans)("net_amount_opened_list", "Net Amount", "order_items")) !== null && _f !== void 0 ? _f : "Net Amount",
                value: "formattedNetAmount",
            },
        ]);
        const orderItemBilledListFields = (0, vue_3.ref)([
            {
                key: "productId",
                label: (_g = (0, i18n_1.trans)("item_id_billed_list", "Item ID", "order_items")) !== null && _g !== void 0 ? _g : "Item ID",
                value: "productId",
            },
            {
                key: "productName",
                label: (_h = (0, i18n_1.trans)("name_billed_list", "Name", "order_items")) !== null && _h !== void 0 ? _h : "Name",
                value: "productName",
            },
            {
                key: "quantity",
                label: (_j = (0, i18n_1.trans)("quantity_billed_list", "Quantity", "order_items")) !== null && _j !== void 0 ? _j : "Quantity",
                value: "quantity",
            },
            {
                key: "formattedPriceUnitNet",
                label: (_k = (0, i18n_1.trans)("net_unit_price_billed_list", "Net Unit Price", "order_items")) !== null && _k !== void 0 ? _k : "Unit Net Price",
                value: "formattedPriceUnitNet",
            },
            {
                key: "formattedNetAmount",
                label: (_l = (0, i18n_1.trans)("net_amount_billed_list", "Net Amount", "order_items")) !== null && _l !== void 0 ? _l : "Net Amount",
                value: "formattedNetAmount",
            },
        ]);
        const orderItemShippedListFields = (0, vue_3.ref)([
            {
                key: "productId",
                label: (_m = (0, i18n_1.trans)("item_id_shipped_list", "Item ID", "order_items")) !== null && _m !== void 0 ? _m : "Item ID",
                value: "productId",
            },
            {
                key: "productName",
                label: (_o = (0, i18n_1.trans)("name_shipped_list", "Name", "order_items")) !== null && _o !== void 0 ? _o : "Name",
                value: "productName",
            },
            {
                key: "quantity",
                label: (_p = (0, i18n_1.trans)("quantity_shipped_list", "Quantity", "order_items")) !== null && _p !== void 0 ? _p : "Quantity",
                value: "quantity",
            },
            {
                key: "formattedPriceUnitNet",
                label: (_q = (0, i18n_1.trans)("net_unit_price_shipped_list", "Net Unit Price", "order_items")) !== null && _q !== void 0 ? _q : "Unit Net Price",
                value: "formattedPriceUnitNet",
            },
            {
                key: "formattedNetAmount",
                label: (_r = (0, i18n_1.trans)("net_amount_shipped_list", "Net Amount", "order_items")) !== null && _r !== void 0 ? _r : "Net Amount",
                value: "formattedNetAmount",
            },
        ]);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.unref)(orderItems).openedItems.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("h1", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("opened_items", "Opened items", "order_items")), 1),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: orderItemOpenedListFields.value,
                            "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((orderItemOpenedListFields).value = $event)),
                            items: (0, vue_2.unref)(orderItems).openedItems,
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-quantity": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(orderItemOpened.quantity), 1)
                            ]),
                            "cell-reservedQuantity": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(orderItemOpened
                                    .reservedQuantity), 1)
                            ]),
                            "cell-formattedPriceUnitNet": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)(orderItemOpened
                                    .formattedPriceUnitNet), 1)
                            ]),
                            "cell-formattedNetAmount": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(orderItemOpened
                                    .formattedNetAmount), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(orderItems).shippedItems.length > 0 &&
                    (0, vue_2.unref)(orderItems).shippedItemsInfo !== null)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                        (0, vue_2.createElementVNode)("h1", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipped_items", "Shipped items", "order_items")), 1),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("packing_slip_id", "Packing Slip ID", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).shippedItemsInfo.packingSlipId), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("created_at_shipped", "Created At", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).shippedItemsInfo.date), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_name", "Delivery Name", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).shippedItemsInfo.deliveryName), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_address", "Delivery Address", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).shippedItemsInfo.deliveryZip) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).shippedItemsInfo.deliveryCity) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).shippedItemsInfo.deliveryStreet), 1)
                            ])
                        ]),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: orderItemShippedListFields.value,
                            "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((orderItemShippedListFields).value = $event)),
                            items: (0, vue_2.unref)(orderItems).shippedItems,
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-quantity": (0, vue_2.withCtx)(({ item: orderItemShipped }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)(orderItemShipped.quantity), 1)
                            ]),
                            "cell-formattedPriceUnitNet": (0, vue_2.withCtx)(({ item: orderItemShipped }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(orderItemShipped
                                    .formattedPriceUnitNet), 1)
                            ]),
                            "cell-formattedNetAmount": (0, vue_2.withCtx)(({ item: orderItemShipped }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)(orderItemShipped
                                    .formattedNetAmount), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(orderItems).billedItems.length > 0 &&
                    (0, vue_2.unref)(orderItems).billedItemsInfo !== null)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                        (0, vue_2.createElementVNode)("h1", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("billed_items", "Billed items", "order_items")), 1),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_id", "Invoice ID", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).billedItemsInfo.invoiceId), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("created_at_billed", "Created At", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).billedItemsInfo.date), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_name", "Invoice Name", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).billedItemsInfo.invoiceName), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("span", _hoisted_21, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_address", "Invoice Address", "order_items")) + ":", 1),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).billedItemsInfo.invoiceZip) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).billedItemsInfo.invoiceCity) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(orderItems).billedItemsInfo.invoiceStreet), 1)
                            ])
                        ]),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: orderItemBilledListFields.value,
                            "onUpdate:fields": _cache[2] || (_cache[2] = ($event) => ((orderItemBilledListFields).value = $event)),
                            items: (0, vue_2.unref)(orderItems).billedItems,
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-quantity": (0, vue_2.withCtx)(({ item: orderItemBilled }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_22, (0, vue_2.toDisplayString)(orderItemBilled.quantity), 1)
                            ]),
                            "cell-formattedPriceUnitNet": (0, vue_2.withCtx)(({ item: orderItemBilled }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)(orderItemBilled
                                    .formattedPriceUnitNet), 1)
                            ]),
                            "cell-formattedNetAmount": (0, vue_2.withCtx)(({ item: orderItemBilled }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_24, (0, vue_2.toDisplayString)(orderItemBilled
                                    .formattedNetAmount), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
